import { useContext, useEffect, useState } from 'react'
import styles from './HeatMapAnalysis.module.less'
// import TimelineTab from './TimelineTab/TimelineTab'
import TimelineTabV1 from './TimelineTabV1/TimelineTabV1'
import {
  PROFESSOR_RATE_BTN_ID_PREFIX,
  RateBtn,
} from '@/pages/ProfessorProjectDetailPage/components/ProfessorRatePanel/ProfessorRatePanel'
import { ProfessorContext } from '@/Contexts/Contexts'
import { DASHBOARD_CONTENT_CONTAINER_ID } from '@/router/pageConst'
import { CATEGORY_TAB_ID } from '../CategoryTab/CategoryTab'
import AiTip from '@/components/AiTip/AiTip'
import { INTERNAL_HOST } from '@/commonConst'
import classNames from 'classnames'
import { isPortraitByProjectInfo } from '@/helpers/productCategory'

interface Props {
  project: ProjectModels.ProjectDetail
  defaultActiveIndex?: number
  mode?: 'professor' | 'default'
}

function HeatMapAnalysis(props: Props) {
  const defaultActiveIndex = props?.defaultActiveIndex || 0
  const isPortraitMode = isPortraitByProjectInfo(props.project)
  const heatMaps = props.project.detailMetrics.map((detail) => {
    return {
      heatMap: detail.heatMap,
      secondCount: detail.secondCount,
    }
  })

  const { showProfessorPanel, unfinishedRateBtn } = useContext(ProfessorContext)
  const [activeHeatMap, setActiveHeatMap] = useState(heatMaps[defaultActiveIndex])
  const onFrameChange = (activeIndex: number) => {
    setActiveHeatMap(heatMaps[activeIndex - 1])
  }


  useEffect(() => {
    if (props.mode === 'professor' && unfinishedRateBtn.length > 0) {
      setTimeout(() => {
        const el = document.getElementById(
          `${PROFESSOR_RATE_BTN_ID_PREFIX}-${unfinishedRateBtn[0]}`
        )
        if (!el) {
          return
        }
        const containerElement = document.getElementById(DASHBOARD_CONTENT_CONTAINER_ID)
        const categoryTabElement = document.getElementById(CATEGORY_TAB_ID)!
        if (containerElement) {
          const top =
            el.getBoundingClientRect().top -
            categoryTabElement.offsetTop -
            categoryTabElement.offsetHeight
          containerElement.scrollTo({
            top: top + containerElement.scrollTop,
            behavior: 'smooth',
          })
        }
      })
    }
  }, [unfinishedRateBtn, props.mode])

  return (
    <div className={styles.heatMapAnalysis}>
      <TimelineTabV1
        activeIndex={defaultActiveIndex + 1}
        project={props.project}
        onFrameChange={onFrameChange}
      />
      <div className={styles.heatMapContent}>
        {props.mode === 'professor' && (
          <span id={`${PROFESSOR_RATE_BTN_ID_PREFIX}-heatMap`}>
            <RateBtn
              rateKey={'heat_map'}
              style={{ marginTop: 16 }}
              onClick={() => {
                showProfessorPanel('heat_map')
              }}
            />
          </span>
        )}

        <div className={classNames(styles.heatMapBox, { [styles.heatMapBoxPortrait]: isPortraitMode })}>
          <div className={styles.heatMap}>
            <img className={styles.heatMapImg} src={activeHeatMap.heatMap} alt='' />
          </div>
        </div>
        {
          INTERNAL_HOST.includes(location.hostname) &&
          <div className={styles.aiTipBox}>
            <AiTip style={{ marginTop: 20, whiteSpace: 'nowrap' }} />
          </div>
        }
      </div>
    </div>
  )
}

export default HeatMapAnalysis
